import React, { useEffect } from 'react';
import SiteHeader from './SiteHeader';
import HomeHero from './HomeHero';
import SchoolHighlights from './SchoolHighlights';
import AboutSection from './AboutSection';
import ChairmanMessage from './ChairmanMessage';
import AcademicsSection from './AcademicsSection';
import CampusLife from './CampusLife';
import SchoolStats from './SchoolStats';
import Testimonials from './Testimonials';
import AdmissionsCTA from './AdmissionsCTA';
import SiteFooter from './SiteFooter';

function Home() {
  useEffect(() => {
    const root = document.querySelector('.bluevale-home');
    if (!root) return undefined;

    const revealItems = root.querySelectorAll('.reveal');
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('in'));
    }

    const dots = root.querySelectorAll('.hero-dots span');
    let activeDot = 0;
    const dotTimer = dots.length ? window.setInterval(() => {
      dots[activeDot].classList.remove('on');
      activeDot = (activeDot + 1) % dots.length;
      dots[activeDot].classList.add('on');
    }, 3200) : null;

    return () => {
      observer?.disconnect();
      if (dotTimer) window.clearInterval(dotTimer);
    };
  }, []);

  return (
    <main className="bluevale-home">
      <SiteHeader />
      <HomeHero />
      <SchoolHighlights />
      <AboutSection />
      <ChairmanMessage />
      <AcademicsSection />
      <CampusLife />
      <SchoolStats />
      <Testimonials />
      <AdmissionsCTA />
      <SiteFooter />
    </main>
  );
}

export default Home;
